export const manifest = {
  screens: {
    scr_n9ryda: { name: "Home", route: "/" },
  },
}
